
export const getSensorReportsPending = () => {
    return {
        type: 'GET_SENSOR_REPORTS_PENDING'
    }
};

export const getSensorReportsSuccess = (sensorReports) => {
    return {
        type: 'GET_SENSOR_REPORTS_SUCCESS',
        sensorReports,
    }
};

export const getSensorReportsError = error => {
    return {
        type: 'GET_SENSOR_REPORTS_ERROR',
        error: error
    }
};


export const getSensorsForMeasurementsSuccess = (sensorsForMeasurements, sensorTypes) => {
    return {
        type: 'GET_SENSORS_FOR_MEASUREMENTS_SUCCESS',
        sensorsForMeasurements,
        sensorTypes
    }
}

export const getSensorsForMeasurementsPending = () => {
    return {
        type: 'GET_SENSORS_FOR_MEASUREMENTS_PENDING',
    }
}

export const getSensorsForMeasurementsError = (error) => {
    return {
        type: 'GET_SENSORS_FOR_MEASUREMENTS_ERROR',
        error: error
    }
}


export const setSensorReportsFilters = filters => {
    return {
        type: 'SET_SENSOR_REPORTS_FILTERS',
        filters: filters
    }
};

const formatDateOnly = date => {
    if (!date) {
        return '';
    }

    if (!(date instanceof Date)) {
        return date;
    }

    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${year}-${month}-${day}`;
};

/**
 * Maps old aggregation period values to new backend enum values.
 * Old: RAW, MIN_30_PERIOD, HOUR_1_PERIOD, DAY_1_PERIOD, MONTH
 * New: RAW, MIN_30, HOUR, DAY, MONTH
 */
const mapAggregationPeriod = (oldValue) => {
    const mapping = {
        'MIN_30_PERIOD': 'MIN_30',
        'HOUR_1_PERIOD': 'HOUR',
        'DAY_1_PERIOD': 'DAY',
        // These remain the same
        'RAW': 'RAW',
        'MIN_30': 'MIN_30',
        'HOUR': 'HOUR',
        'DAY': 'DAY',
        'MONTH': 'MONTH',
    };
    return mapping[oldValue] || oldValue || '';
};

/**
 * Computes dateFrom from numberOfDaysInPast relative to today.
 */
const computeDateFromDays = (numberOfDaysInPast) => {
    if (!numberOfDaysInPast) return null;
    const today = new Date();
    const dateFrom = new Date(today);
    dateFrom.setDate(today.getDate() - Number(numberOfDaysInPast));
    return dateFrom;
};

/**
 * Builds the request body for the new /reports/measurements/sensor endpoint.
 * Handles conversion of numberOfDaysInPast to dateFrom/dateTo.
 */
const buildReportRequestBody = (filters) => {
    let dateFrom = filters && filters.dateFrom ? formatDateOnly(filters.dateFrom) : '';
    let dateTo = filters && filters.dateTo ? formatDateOnly(filters.dateTo) : '';

    // Explicit dates take precedence over a stale relative-range preference.
    if (filters && filters.numberOfDaysInPast && !dateFrom && !dateTo) {
        const computedDateFrom = computeDateFromDays(filters.numberOfDaysInPast);
        if (computedDateFrom) {
            dateFrom = formatDateOnly(computedDateFrom);
        }
        dateTo = formatDateOnly(new Date());
    }

    // Use first sensorId from sensorIds array (new API supports single sensor)
    const sensorId = filters && filters.sensorIds && filters.sensorIds.length > 0
        ? filters.sensorIds[0]
        : (filters && filters.sensorId ? filters.sensorId : '');

    return {
        sensorId: sensorId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        aggregationPeriod: mapAggregationPeriod(
            filters && filters.aggregationPeriod
                ? filters.aggregationPeriod
                : (filters && filters.measurementsPeriodAggregation ? filters.measurementsPeriodAggregation : '')
        ),
        withBattery: Boolean(filters && filters.withBattery),
    };
};

export const getSensorsForMeasurements = (filters) => {
    return dispatch => {
        dispatch(getSensorsForMeasurementsPending());

        fetch(`${process.env.REACT_APP_API_URL}/panel/sensor_list_for_measurement_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                userId: filters.userId ? filters.userId : 0,
                companyId: filters.companyId ? filters.companyId : 0,
                page: 1,
                lat: filters.lat ? filters.lat : '',
                lon: filters.lon ? filters.lon : '',
                sensorType: filters.sensorType ? filters.sensorType : '',

            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsForMeasurementsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorsForMeasurementsSuccess(res, res.sensorTypes))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}



export const getSensorReports = (filters) => {

    return dispatch => {
        dispatch(getSensorReportsPending());

        const requestBody = buildReportRequestBody(filters);

        fetch(`${process.env.REACT_APP_API_URL}/reports/measurements/sensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(requestBody)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorReportsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorReportsSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};



/**
 * Downloads the sensor report as CSV file.
 * Uses new endpoint: POST /reports/measurements/sensor/csv
 */
export const downloadSensorReportCsv = (filters) => {

    return dispatch => {

        const requestBody = buildReportRequestBody(filters);

        fetch(`${process.env.REACT_APP_API_URL}/reports/measurements/sensor/csv`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `sensor_report_${requestBody.sensorId}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove()
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

/**
 * Downloads the sensor report as PDF file.
 * Uses new endpoint: POST /reports/measurements/sensor/pdf
 */
export const downloadSensorReportPdf = (filters) => {

    return dispatch => {

        const requestBody = buildReportRequestBody(filters);

        fetch(`${process.env.REACT_APP_API_URL}/reports/measurements/sensor/pdf`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `sensor_report_${requestBody.sensorId}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove()
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
